"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.starts-with");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _category = require("@/api/goods/category");
var _goods = require("@/api/goods/goods");
var _primaryMenu = require("@/api/goods/primaryMenu");
var _sortablejs = require("sortablejs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'categoryManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        parentId: 1,
        keywords: null,
        hasMapping: null,
        menuInfoId: null
      },
      mappingFilter: null,
      editVisible: false,
      editForm: {
        id: null,
        categoryName: '',
        categoryCode: '',
        categoryDesc: '',
        menuInfoId: null
      },
      editRules: {
        categoryName: [{
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }],
        categoryCode: [{
          required: true,
          message: '请输入分组编码',
          trigger: 'blur'
        }]
      },
      selectEntity: {},
      selectDataQuery: {
        page: 1,
        limit: 10,
        parentId: null,
        keywords: null
      },
      selectDataList: [],
      selectDataTotal: 0,
      goodsVisible: false,
      goodsQuery: {
        page: 1,
        limit: 10,
        categoryFirstId: null,
        categorySecondId: null,
        type: null,
        keywords: null
      },
      goodsList: [],
      goodsTotal: 0,
      menuInfos: []
    };
  },
  created: function created() {
    this.getList();
    this.getPrimaryMenuList();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    getPrimaryMenuList: function getPrimaryMenuList() {
      var _this = this;
      (0, _primaryMenu.queryList)({
        limit: 1000
      }).then(function (res) {
        _this.menuInfos = res.records;
      });
    },
    handleMappingFilterChange: function handleMappingFilterChange(val) {
      if (val === 'unmapped') {
        this.listQuery.hasMapping = 0;
        this.listQuery.menuInfoId = null;
      } else if (val && val.startsWith('mapped_')) {
        this.listQuery.hasMapping = 1;
        this.listQuery.menuInfoId = parseInt(val.replace('mapped_', ''));
      } else {
        this.listQuery.hasMapping = null;
        this.listQuery.menuInfoId = null;
      }
      this.handleFilter();
    },
    gotoSecondCategory: function gotoSecondCategory(row) {
      this.$emit('showSecondCategory', row);
    },
    openGoodsVisible: function openGoodsVisible(row, type) {
      if (type == 1) {
        this.goodsQuery.categoryFirstId = row.id;
        this.goodsQuery.categorySecondId = null;
      } else {
        this.goodsQuery.categoryFirstId = null;
        this.goodsQuery.categorySecondId = row.id;
      }
      this.selectEntity = row;
      this.goodsQuery.type = type;
      this.goodsQuery.page = 1; // 重置分页
      this.goodsQuery.keywords = null; // 清空搜索
      this.goodsVisible = true;
      this.getGoodsList();
    },
    getGoodsList: function getGoodsList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _goods.queryList)(this.goodsQuery).then(function (response) {
        if (response) {
          _this2.goodsList = response.records;
          _this2.goodsTotal = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    getSelectDataList: function getSelectDataList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _category.queryList)(this.selectDataQuery).then(function (response) {
        if (response) {
          _this3.selectDataList = response.records;
          _this3.selectDataTotal = response.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    openSecondVisible: function openSecondVisible(row) {
      this.selectEntity = row;
      this.selectDataQuery.parentId = row.id;
      this.getSelectDataList();
      this.secondVisible = true;
    },
    saveEntity: function saveEntity() {
      var _this4 = this;
      this.$refs.editFormRef.validate(function (valid) {
        if (valid) {
          (0, _category.update)(_this4.editForm).then(function () {
            _this4.$message.success(_this4.editForm.id ? '编辑成功' : '新增成功');
            _this4.editVisible = false;
            if (_this4.secondVisible) {
              _this4.getSelectDataList();
            } else {
              _this4.getList();
            }
          }).catch(function () {
            _this4.$message.error('保存失败');
          });
        }
      });
    },
    openEditDialog: function openEditDialog(id) {
      var _this5 = this;
      (0, _category.getById)(id).then(function (res) {
        _this5.editForm = res.data;
        _this5.editVisible = true;
      });
    },
    getList: function getList() {
      var _this6 = this;
      this.listLoading = true;
      (0, _category.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this6.dataList = response.records;
          _this6.total = response.total;
        }
        setTimeout(function () {
          _this6.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this6.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    }
  }
};